<template>
    <div>
      <div class="card" style="padding:5px 10px 5px; border-radius: 10px;">
          <div class="card-header">
              <div class="row">
                  <div class="col-md-10">
                      <strong style="font-size:20px">Información de pagos a terapeutas</strong><br>
                      <span style="color:darkgray">Información por terapeuta</span> <br>
                      <span style="color:darkgray">Resumen: <span style="color:green"> <i class="fa fa-arrow-up" style="color:green;"></i> {{ resumenGanancias }}</span> || <span style="color:red"> <i class="fa fa-arrow-down" style="color:red;"></i> {{ resumenDeucciones }}</span></span>
                  </div>
                  <!-- <div class="col-md-2">
                      <button class="btn pull-right" style="border-radius: 8px;" @click="abrirModal()">
                          <i class="fa fa-arrow-right"></i>
                      </button>
                  </div> -->
              </div>
          </div>
          <hr>
          <div class="card-content" style="max-height: 400px; overflow: scroll; overflow-x: hidden;">
              <div class="row">
                  <div class="col-md-12" v-for="persona in informacionNomina" :key="persona.nombre">
                      <div class="card" style="border:1px darkgray solid;">
                          <div class="card-content">
                              <div class="row">
                                  <div class="col-md-3">
                                      <strong>{{ persona.nombre }}</strong> <br>
                                      <small style="color:grey;">NOMBRE COMPLETO</small>
                                  </div>
                                  <div class="col-md-3">
                                      <i class="fa fa-arrow-up" style="color:green;"></i>
                                      <strong style="color:green"> {{ persona.ingreso }}</strong> <br>
                                      <small style="color:grey;">SESIONES REALIZADAS</small> <br>
                                      
                                  </div>
                                  <div class="col-md-3">
                                      <i class="fa fa-arrow-up" style="color:green;"></i>
                                      <strong> {{ persona.adicional }}</strong> <br>
                                      <small style="color:grey;">INGRESOS ADICIONALES</small>
                                  </div>
                                  <div class="col-md-3">
                                      <i class="fa fa-arrow-down" style="color:red;"></i>
                                      <strong> {{ persona.deducciones }}</strong> <br>
                                      <small style="color:grey;">DEDUCCIONES</small>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  <script>
  import nomicard from "src/components/aDashboard/nomina/cardnomina.vue"
  import axiosInstance from "src/global-services/axiosInstance";
  import formatearPesosColombianos from "../../../global-services/formatear-pesos";
  export default {
      data(){
          return {
              informacionNomina: [],
              resumenGanancias: 0,
              resumenDeucciones: 0
          }
      },
      methods: {
          getNominaTerapeutas: async function(fechaInicial, fechaFinal){
              try{
                  this.$modal.show('carga');
                  const BASE_URL = `api/informacion-dashboard-terapeuta/${fechaInicial}/${fechaFinal} `;
                  const response = await axiosInstance.get(BASE_URL);
                  if(response.data.status === true){
                      const data = response.data.data; 
                      let resumenGananciasF = 0;
                      let resumenDeuccionesF = 0;
                      let dataFormated = data.map(element => {
                          resumenGananciasF += parseInt(element.Realizadas) + parseInt(element.adicionales);
                          resumenDeuccionesF += parseInt(element.deducciones)
                          return {
                              nombre : element.terapeuta,
                              ingreso: formatearPesosColombianos(element.Realizadas),
                              deducciones: formatearPesosColombianos(element.deducciones),
                              adicional: formatearPesosColombianos(element.adicionales),
                          }
                      });
                      this.resumenGanancias = formatearPesosColombianos(resumenGananciasF);
                      this.resumenDeucciones = formatearPesosColombianos(resumenDeuccionesF);
                      this.informacionNomina = dataFormated;
                  }
              }catch(error){
                  console.log(error);
              }finally{
                this.$modal.hide('carga');
              }
          }
      },
      components: {
          nomicard
      },
      mounted(){
          // this.getNomina()
      }
  }
  </script>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/informacionGastoTerapeutas.vue